var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExcel(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3034 1.36571H9.51486V0L0 1.47041V14.3591L9.51486 16V13.9758H15.3034C15.4788 13.985 15.6507 13.9241 15.7813 13.8065C15.9119 13.6889 15.9906 13.5243 16 13.3487V1.9922C15.9904 1.81671 15.9117 1.6522 15.7811 1.53475C15.6505 1.4173 15.4787 1.35651 15.3034 1.36571ZM15.3949 13.4528H9.49543L9.48571 12.372H10.9069V11.1133H9.47486L9.468 10.3695H10.9069V9.11082H9.45714L9.45029 8.36703H10.9069V7.10831H9.44571V6.36453H10.9069V5.10581H9.44571V4.36202H10.9069V3.10331H9.44571V1.95902H15.3949V13.4528Z",
    fill: "#20744A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7069 3.10159H14.1771V4.36031H11.7069V3.10159ZM11.7069 5.10467H14.1771V6.36338H11.7069V5.10467ZM11.7069 7.10774H14.1771V8.36646H11.7069V7.10774ZM11.7069 9.11082H14.1771V10.3695H11.7069V9.11082ZM11.7069 11.1139H14.1771V12.3726H11.7069V11.1139Z",
    fill: "#20744A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.484 4.9519L3.71029 4.88153L4.48114 7.00361L5.392 4.79399L6.61829 4.72362L5.12914 7.73653L6.61829 10.7569L5.32171 10.6693L4.44629 8.36703L3.57029 10.5818L2.37886 10.4765L3.76286 7.80862L2.484 4.9519Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcel);
export default __webpack_public_path__ + "static/media/excel.13ed8e6ae3cfdf5fa7450cb59040a37e.svg";
export { ForwardRef as ReactComponent };